module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e49d52e74b7689a0727d.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.halflings.pro/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/assets/css/fonts/glyphicons.halflings.pro/glyphicons-halflings-regular.ttf
// module chunks = 2